import React from "react";

/**
 * Small inline loading indicator with a status label.
 *
 * Moved from business/shared/SourceMessageAccordion.js (Phase 5a) -- used by
 * both products' loading states, not mantis-specific. That file now imports
 * it from here instead of defining it locally.
 *
 * @example
 * <InlineSpinner text="Loading..." />
 */
const InlineSpinner = ({ text }) => (
  <div className="business-inline-spinner" role="status" aria-live="polite">
    <span className="business-inline-spinner__icon" aria-hidden="true" />
    <span>{text}</span>
  </div>
);

export default InlineSpinner;
export { InlineSpinner };
